import { Row, Col, Typography, Input, Form, message } from "antd";
import { useTranslation } from "react-i18next";
import { setTeamName } from "shared/service/StrmService";

const FormName: React.FC<any> = (props) => {
  const { onNext, team } = props;
  const { t } = useTranslation("radar");
  const [form] = Form.useForm();

  const onFinish = async () => {
    const { displayName } = form.getFieldsValue(true);
    const { id } = team;
    const response = await setTeamName({ displayName, id });
    if (response) onNext();
    else message.error(t("pages.TeamStart.usedEmail"));
  };

  return (
    <Form layout="vertical" form={form} onFinish={onFinish}>
      <Row>
        <Col xs={24}>
          <Typography.Title style={{ fontSize: 50 }}></Typography.Title>
        </Col>
        <Col xs={24}>
          <Typography.Title
            style={{ color: "#949494", fontSize: 25, marginBottom: 36 }}
          >
            {t("pages.TeamStart.diclaimer")}
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Col xs={24}>
            <Form.Item label={t("pages.TeamStart.name")} name="displayName">
              <Input
                placeholder={t("pages.TeamStart.namePlaceHolder")}
                style={{ textAlign: "start" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} style={{ color: "#fff" }}>
            <button
              style={{ margin: "32px 0" }}
              className="border-preenchido-colorido"
              type="submit"
            >
              {t("pages.TeamStart.next")}
            </button>
          </Col>
        </Col>
      </Row>
    </Form>
  );
};

export default FormName;
